module.exports = __webpack_public_path__ + "img/locker-room-gal-1.08d38399.jpg";